export default __webpack_public_path__ + "static/media/randomEvent2BHS.07c940ae.mp4";